export default __webpack_public_path__ + "static/media/bathtub.7fbd6af5.svg";